import particlesPackage from 'particles.js/particles';
import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';

function teaserArticle() {

    const animatedCircles = $qsa('[data-name="teaser-animated-circle"]');

    if (!animatedCircles) return;

    [...animatedCircles].forEach((animatedCircle) => {


        $qs('body').addEventListener('mousemove', (e) => {

            let x = e.clientX;
            let y = e.clientY;
            let distance = 80;
            x = x - animatedCircle.getBoundingClientRect().left + animatedCircle.offsetWidth/2 - screen.width/2;
            y = y - animatedCircle.getBoundingClientRect().top + animatedCircle.offsetHeight/2 - screen.height/2;

            // y = y - screen.height/2;
            x = x / distance;
            y = y / distance;
           
            gsap.to( animatedCircle, { transformOrigin: 'center', x: x, y: y, duration: 0.5 } );
        })

        });



}


export default teaserArticle;